import React, { Component } from 'react';
//import ReactDOM from "react-dom/client";
//import { w3cwebsocket as W3CWebSocket } from "websocket";
//import LogRocket from 'logrocket';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet'
import { Icon } from "leaflet";
import L from "leaflet";
import moment from 'moment';
import ReactDOMServer from 'react-dom/server';
import axios from "axios"

import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import AuthService from '../services/auth-service';
import utils from '../utils';
import { Link } from 'react-router-dom';

// ***

function SvgImage({fill_color, opacity}) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill={fill_color} opacity={opacity} d="M11.0751 23.5158C4.26422 13.6421 3 12.6287 3 9C3 4.02942 7.02942 0 12 0C16.9706 0 21 4.02942 21 9C21 12.6287 19.7358 13.6421 12.9249 23.5158C12.478 24.1614 11.522 24.1614 11.0751 23.5158ZM12 12.75C14.0711 12.75 15.75 11.0711 15.75 9C15.75 6.92892 14.0711 5.25 12 5.25C9.92892 5.25 8.25 6.92892 8.25 9C8.25 11.0711 9.92892 12.75 12 12.75Z" />
    </svg>

  )
}

function subtractHours(numOfHours, date = new Date()) {
  date.setHours(date.getHours() - numOfHours)
  return date;
}

const last_minutes = 30

export default class ServiceUserMap extends React.Component {
  constructor(props) {    
    super(props); 
    this.state = { 
      rows: [],
      last_date: moment().utc().subtract(last_minutes, 'minutes'),
      max_num_rows: 100,
      loading: true,
      my_timeout: undefined,
    }    
    this.stop_timer = false
  }
  changeMapPos(latlng, zoom, duration) {
    //const map = this.mapInstance.leafletElement 
    //console.log(this.mapInstance)
    if (this.mapInstance) {
      this.mapInstance.flyTo(latlng, zoom, {
        duration: duration
      })      
    }
  }
  async process_poll_rows(rows) {
    if (rows.length > 0) {      
      var processed_rows = await rows.map(row => {
        if (row.geo !== null) {
          var geo = JSON.parse(atob(row.geo))        
          row.lat = geo.lat
          row.lon = geo.lon
          row.city = geo.city
          row.country = geo.country        
        } else {
          console.log("geo null at " + row.id)
        }
        return row
      })  
      //console.log("processed_rows", processed_rows)    
      var joined = this.state.rows.concat(processed_rows)
      var num = 0
      joined = joined.map(row => {
        row.num = num++
        return row
      })
      var item = processed_rows.at(-1)
      console.log("Last item", item)    
      this.setState({
        rows: joined,        
        last_date: moment(item.date_insert), // mi segno l'ora del piu' recente
      })
      this.changeMapPos([item.lat, item.lon], 5, 1)
    }    
  }
  async poll() {
    console.log("xxxxxxxxxxxxxx Poll at " + this.state.last_date.format("HH:mm:ss"))
    AuthService.getLogUpdateSince(this.state.last_date, this.state.max_num_rows).then(data => {
      var to_value = 10000
      if (data.is_valid) {        
        console.log(`Log updates since ${this.state.last_date.format("HH:mm:ss")}: ${data.rows.length}`)
        console.log(data.rows)
        this.process_poll_rows(data.rows)
        if (data.rows.length > 0) {
          to_value = 1000
        }
      } else {
        console.log("... not valid data")
        to_value = 1000
      }      
      if (!this.stop_timer) {
        //console.log("to value = " + to_value)
        var my_timeout = setTimeout(this.poll.bind(this), to_value)
        this.setState({
          my_timeout: my_timeout
        })
      }
      this.setState({
        loading: false
      })
    }).catch(e => {
      console.log(e) 
    })
  }
  componentDidMount() {   
    this.poll()
  }
  componentWillUnmount() {
    this.stop_timer = true
    if (this.state.my_timeout) {
      clearTimeout(this.state.my_timeout)
    }
  }
  render() {
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />
    if (!utils.userHasRoleAdmin(this.props.authStatus.user)) return <UserAuthRequired notallowed />

    const MarkerIcon = L.divIcon({
      className: 'custom-icon',
      popupAnchor: [6.5, 21],
      html: ReactDOMServer.renderToString(<SvgImage fill_color="#B50B0B" opacity={0.1}/>),
    })

    function getMarkerIcon(p_opacity, p_fill_color) {
      return L.divIcon({
        className: 'custom-icon',
        popupAnchor: [6.5, 21],
        html: ReactDOMServer.renderToString(<SvgImage fill_color={p_fill_color} opacity={p_opacity}/>),
      })
    }
    
    var t0_temp = moment().utc().subtract(last_minutes, 'minutes')    
    var t0 = moment(t0_temp.format('YYYY-MM-DD HH:mm:ss'))

    var rows = this.state.rows.filter(row => {
      if (row.geo === null) return false
      //console.log("row0", row) 
      var t1 = moment(row.date_insert)
      //console.log("t0", t0.format('YYYY-MM-DD HH:mm:ss'))
      //console.log("t1", t1.format('YYYY-MM-DD HH:mm:ss'))
      const isT1GreaterThanT0 = t1.isAfter(t0);
      //console.log("t1 > t0", isT1GreaterThanT0);
      return (t1 > t0)
    }).map(row => {
      var n = moment(row.date_insert).unix() - t0.unix()
      //console.log("n", n)
      row.opacity = n / (last_minutes * 60)
      row.fill_color = "black"
      if (!row.user_id)
        row.fill_color = "darkgreen"      
      return row
    })
    if (rows.length > 0) rows.at(-1).fill_color = "#B50B0B"

    var height = "calc(100vh - " + this.props.navbarHeight + ")"
    return (
      <>    
        <MapContainer 
          ref={e => { this.mapInstance = e }}
          style={{
            height: `${height}`,
          }}
          center={[41.9, 12.5]} 
          zoom={3} 
          scrollWheelZoom={true} 
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {!this.state.loading && rows.map(row =>
            <Marker 
              key={`marker-${row.num}`}
              position={[row.lat, row.lon] /* rome */} icon={getMarkerIcon(row.opacity, row.fill_color)}>
              <Popup>
                {row.sw_name} v{row.sw_ver}
                <br />
                {row.username && (
                    <Link to={"/service/user/details/" + row.user_id}>
                      {row.username}
                    </Link>                    
                )}
                {!row.username && (
                  <b>NOT REGISTERED</b>
                )}                
                <br />
                {row.city} ({row.country})
                <br />
                {moment(row.date_insert).format("DD/MM/YYYY HH:mm:ss")}
                {/* <br /> {item.user_code} */}
              </Popup>
            </Marker>
          )}
        </MapContainer>
      </>
    )
  }
}
